import React from 'react';
import { Button } from '../ui/Button';
import { HelpCircle } from 'lucide-react';

interface ClarificationMessageProps {
  question: string;
  suggestions?: string[];
  onSuggestionSelect?: (suggestion: string) => void;
}

export function ClarificationMessage({ 
  question, 
  suggestions = [], 
  onSuggestionSelect 
}: ClarificationMessageProps) {
  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700/50 rounded-lg p-4 mb-4">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <HelpCircle className="w-5 h-5 text-amber-600 dark:text-amber-400 mt-0.5" />
        </div>
        
        <div className="flex-1">
          <h4 className="text-sm font-medium text-amber-800 dark:text-amber-200 mb-2">
            I need a bit more information
          </h4>
          
          <p className="text-sm text-amber-700 dark:text-amber-300 mb-4">
            {question}
          </p>
          
          {suggestions && suggestions.length > 0 && (
            <div>
              <p className="text-xs text-amber-600 dark:text-amber-400 mb-2 font-medium">
                Here are some suggestions:
              </p>
              <div className="space-y-2">
                {suggestions.map((suggestion, index) => (
                  <Button
                    key={index}
                    variant="outline"
                    size="sm"
                    onClick={() => onSuggestionSelect?.(suggestion)}
                    className="text-left justify-start w-full text-amber-700 dark:text-amber-300 border-amber-300 dark:border-amber-600 hover:bg-amber-100 dark:hover:bg-amber-800/30 hover:border-amber-400 dark:hover:border-amber-500 bg-white dark:bg-transparent"
                  >
                    <span className="text-amber-600 dark:text-amber-400 mr-2">💡</span>
                    {suggestion}
                  </Button>
                ))}
              </div>
            </div>
          )}
          
          <div className="mt-4 pt-3 border-t border-amber-200 dark:border-amber-700/50">
            <p className="text-xs text-amber-600 dark:text-amber-400">
              Try being more specific about metrics, time periods, or dimensions you're interested in.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
} 